import { CATEGORIES } from '@app/src/config/categories';
import { CategoryDTO } from '@app/src/views/Home/listProducts/dto/CategoryDTO';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

export const hydrateData = (data: CategoryDTO[]): CategoryModel[] => {
  let newData = data.map(categorie => ({
    id: categorie.id,
    alias: categorie.alias,
    text: categorie.name,
    price: categorie.description,
    icon: CATEGORIES[categorie.alias]['icon'],
    paths: CATEGORIES[categorie.alias]['paths'],
    active: CATEGORIES[categorie.alias]['active'],
    order: CATEGORIES[categorie.alias]['order'],
    color: CATEGORIES[categorie.alias]['color'],
    nameAlias: CATEGORIES[categorie.alias]['nameAlias'],
    typePayment: 'purchase-print'
  }));
  return newData.sort((a, b) => { return a.order - b.order });
};

export const hydrateDataSelectCategories = (data: CategoryModel[]) =>
  data.map((item) => ({
    value: String(item.id),
    text: item.text,
    data: { ...item }
  })) as SelectItemModel[];
